import { useEffect, useMemo } from "react";
import type { RowData } from "@tanstack/react-table";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import clsx from "clsx";

import styles from "./styles.module.scss";
import { Tbody } from "./tbody/tbody";
import type { ITableProps } from "./types";

import { TableNoData } from "@components/atoms/tableNoData";
import { Thead } from "@components/organisms/table/thead/thead";

/**
 * TODO:add font and all typography
 */

export function Table<TData extends RowData>(props: ITableProps<TData>) {
  const {
    columnDef,
    dataJSON,
    thead = true,
    showRow = true,
    hasActionCell = false,
    tableClassName,
    tableContainerClassName,
    onRowSelectionChange,
  } = props;
  const finalData = useMemo(() => dataJSON, [dataJSON]);
  const finalColumnDef = useMemo(() => columnDef, [columnDef]);
  const table = {
    columnDef: finalColumnDef,
    dataJSON: finalData,
  };

  const tableInstance = useReactTable<TData>({
    columns: table.columnDef,
    data: table.dataJSON,
    getCoreRowModel: getCoreRowModel(),
    enableMultiRowSelection: true,
  });

  const selectedRows = tableInstance.getSelectedRowModel().rows;

  useEffect(() => {
    onRowSelectionChange?.(selectedRows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  return (
    <div className={clsx([styles["table-container"], tableContainerClassName])}>
      <table className={clsx([styles.table, tableClassName])}>
        {thead && dataJSON?.length > 0 && (
          <Thead
            tableInstance={tableInstance}
            hasActionCell={hasActionCell}
            showRow={showRow}
          />
        )}
        {dataJSON?.length > 0 ? (
          <Tbody
            tableInstance={tableInstance}
            hasActionCell={hasActionCell}
            showRow={showRow}
          />
        ) : (
          <tbody>
            <tr>
              <td>
                <TableNoData />
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
  );
}
